import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import {
  setStep,
  addPageVisited,
  addPageSubmitted,
  removeSubmittedPage,
  clearStepTracker,
} from './actions';

const stepsSelector = (state) => {
  return state.steps.step;
};
const pagesVisitedSelector = (state) => {
  return state.steps.pagesVisited;
};
const pagesSubmittedSelector = (state) => {
  return state.steps.pagesSubmitted;
};

export const useSteps = () => {
  return {
    step: useSelect(stepsSelector),
    pagesVisited: useSelect(pagesVisitedSelector),
    pagesSubmitted: useSelect(pagesSubmittedSelector),
    setStep: useAction(setStep),
    addPageVisited: useAction(addPageVisited),
    addPageSubmitted: useAction(addPageSubmitted),
    removeSubmittedPage: useAction(removeSubmittedPage),
    clearStepTracker: useAction(clearStepTracker),
  };
};
